import styled from 'styled-components';
import Colors from '../../style/universal.color';
import FONTS from '../../style/fonts';
import { SpotContainer } from '../Spot/spot.style';

const { mlbBlack, mlbGrey2, mlbWhite } = Colors;

export const LoadingWrapper = styled.div`
  display: flex;
  padding: 12px 0px;
  > div:first-child {
    margin-right: 16px;
  }
`;

export const LoadingTextWrapper = styled.div`
  width: calc(100% - 52px);
  div {
    margin-top: 10px;
  }
`;

export const HeadlineItemWrapper = styled.div`
  display: flex;
  ${SpotContainer} {
    flex-shrink: 0;
    margin-right: 16px;
  }
  padding: 12px 0px;
`;

interface HeadlineStackWrapperProps {
  bordersEnabled?: boolean;
}

export const HeadlineStackWrapper = styled.ul<HeadlineStackWrapperProps>`
  font-family: ${FONTS.primaryFont};
  font-size: 19px;
  font-weight: bold;
  line-height: 19px;
  list-style-type: none;
  padding-inline-start: 0px;
  margin-block-start: 0px;
  margin-block-end: 0px;

  a {
    display: block;
    &:not(:last-child) {
      ${HeadlineItemWrapper} {
        ${({ bordersEnabled }) => (bordersEnabled ? `border-bottom: 1px solid ${mlbGrey2};` : '')}
      }
    }
  }
  ${LoadingWrapper} {
    &:not(:last-child) {
      ${({ bordersEnabled }) => (bordersEnabled ? `border-bottom: 1px solid ${mlbGrey2};` : '')}
    }
  }
`;

export const HeadlineWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 36px;
  color: ${({ theme }) => (theme.dark ? mlbWhite : mlbBlack)};
`;
